import {get as _get, find as _find, random as _random, isEmpty as _isEmpty} from 'lodash';

import initialState from '../initialstate';
import {
	GET_GA_INSTRUCTIONS,
	CREATE_GA_INSTRUCTIONS,
	EDIT_GA_INSTRUCTIONS,
	DELETE_GA_INSTRUCTIONS,
	CREATE_PUBLISH_CHANGES,
	CREATE_GA_SECTION,
	EDIT_GA_SECTION,
	DELETE_GA_SECTION,
	SET_LATEST_PUBLISH,
	UPDATE_DOCUMENT_NAME_ON_INSTRUCTIONS,
	DELETE_DOCUMENT_ON_INSTRUCTIONS
} from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import normalizeInstructions, {sortAll} from './normalizeInstructions';
import {normalizeCreateSection, normalizeDeleteSection, normalizeEditSection} from './normalizeSectionActions';
import {
	normalizeCreateInstruction,
	normalizeDeleteInstruction,
	normalizeEditInstruction
} from './normalizeInstructionActions';
import {normalizeDeleteDocument, normalizeRenameDocument} from './normalizeDocumentActions';

export default function GAInstructionsReducer(state = initialState.gaInstructions, action) {
	switch (action.type) {
		case GET_GA_INSTRUCTIONS: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				return normalizeInstructions(data);
			}
			return [];
		}
		case CREATE_GA_INSTRUCTIONS: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Created) {
				const sectionId = _get(action, 'meta.api.data.sectionId', 0);
				const instruction = _get(action, 'response.instructions[0]', null);
				return sortAll(normalizeCreateInstruction({state, sectionId, instruction}));
			}
			return state;
		}
		case EDIT_GA_INSTRUCTIONS: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const instruction = _get(action, 'response', null);
				return sortAll(normalizeEditInstruction({state, instruction}));
			}
			return state;
		}
		case CREATE_GA_SECTION: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const sectionId = _get(action, 'responseObj.data.id', []);
				const sectionName = _get(action, 'responseObj.data.groupSectionName', []);
				return sortAll(normalizeCreateSection(state, sectionId, sectionName));
			}
			return state;
		}
		case EDIT_GA_SECTION: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const sectionId = _get(action, 'meta.api.data[0].value', null);
				const sectionName = _get(action, 'meta.api.data[1].value', null);
				return normalizeEditSection(state, sectionId, sectionName);
			}
			return state;
		}
		case DELETE_GA_INSTRUCTIONS: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.NoContent) {
				const instructionId = _get(action, 'instructionId', null);
				const sectionId = _get(action, 'sectionId', null);
				return normalizeDeleteInstruction({state, sectionId, instructionId});
			}
			return state;
		}
		case DELETE_GA_SECTION: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.NoContent) {
				const sectionId = _get(action, 'sectionId', null);
				return normalizeDeleteSection(state, sectionId);
			}
			return state;
		}
		case SET_LATEST_PUBLISH: {
			if (state) {
				return [...state].map((section) => {
					return {
						...section,
						lastPublishDate: new Date().toISOString()
					};
				});
			}
			return state;
		}
		case CREATE_PUBLISH_CHANGES: {
			return state;
		}
		case UPDATE_DOCUMENT_NAME_ON_INSTRUCTIONS: {
			if (state) {
				return normalizeRenameDocument(state, action.payload);
			}
			return state;
		}
		case DELETE_DOCUMENT_ON_INSTRUCTIONS: {
			if (state) {
				return normalizeDeleteDocument(state, action.payload);
			}
			return state;
		}
		default:
			return state;
	}
}
